import React from 'react';
import { Calendar } from 'lucide-react';
import { dateToKey } from '../../helpers';
import { ClassData } from '../../types';

interface AdminCalendarProps {
    dates: Date[];
    selectedDay: Date;
    setSelectedDay: (date: Date) => void;
    classesByDate: Record<string, ClassData[]>;
}

const AdminCalendar: React.FC<AdminCalendarProps> = ({ dates, selectedDay, setSelectedDay, classesByDate }) => {
    return (
        <div className="bg-slate-900 p-4 rounded-xl shadow-sm border border-slate-700 max-h-[60vh] overflow-y-auto custom-scrollbar">
            <h2 className="font-serif text-lg mb-4 text-slate-300 flex items-center gap-2"><Calendar size={18} /> Admin Calendar</h2>
            <div className="flex flex-col gap-1">
            {dates.map((date) => {
                const key = dateToKey(date);
                const isSelected = key === dateToKey(selectedDay);
                const dayHasClasses = !!classesByDate[key] && classesByDate[key].length > 0;
                return (
                <button key={dateToKey(date)} onClick={() => setSelectedDay(date)}
                    className={`text-left px-4 py-3 rounded-lg text-sm flex justify-between items-center ${isSelected ? 'bg-fuchsia-600 text-white font-semibold' : 'hover:bg-slate-700 text-slate-300'}`}>
                    <span className="flex flex-col"><span className="text-xs uppercase opacity-75">{date.toLocaleDateString('en-US', { weekday: 'short' })}</span><span className="text-lg">{date.getDate()}</span></span>
                    {dayHasClasses && <div className="w-1.5 h-1.5 rounded-full bg-emerald-500" />}
                </button>
                );
            })}
            </div>
        </div>
    );
};

export default AdminCalendar;
